import React from "react";
import { retrieveFirmContactData, retrieveFirmContactDataByTaxId } from "../api/DelegateAPI"
import { refreshAccessToken } from "../api/oauthAPI";
import { retrieveOrgByEid } from "../api/mdmAPI";
import '../css/Formatting.css';

export default function Search(props) {

  async function handleSubmit() {

    props.setSpinnerActive(true)

    const input = document.getElementById("firmSearchText").value.toUpperCase()

    let resp = null;
    if(input !== null && input !== undefined && input.length > 8) {
      let token = props.user.access_token;
      if (props.user.expired) {
        token = await refreshAccessToken(props.user.refresh_token);
      }

      props.setSearchValue(input);

      if(isNumber(input)){
        //tax id search
        resp= await retrieveFirmContactDataByTaxId(token, input)
      } else {
        //eid search
        resp= await retrieveFirmContactData(token, input)
      }
      if ((resp.responseBody != null) && (resp.responseBody[0].eid.length > 8)) {
        props.setGlobalAlert(
          {
            hidden: true,
          }
        )        
        props.setData(resp.responseBody);
        // get firm address
        const firmEid = resp.responseBody[0].eid
        const singleFirmEid = firmEid.substring(0, 9)
        const addressResp = await retrieveOrgByEid(token, singleFirmEid);
        if (addressResp.addresses && addressResp.addresses.length > 0) {
          let address = addressResp.addresses[0].cleansedAddress
          props.setAddress(address);
        } else {
          props.setAddress({});
        }
      } else {
        props.setGlobalAlert(
          {
            id: "none-Found-alert",
            type: "error",
            message:
            "No Firm Found.",
            hidden: false,
          }
        )        
      }
    } else {
      document.getElementById("firmSearchText").focus()
    }

    props.setSpinnerActive(false)

  }
  function isNumber(num){
    return !isNaN(parseFloat(num)) && isFinite(num);
  }
  return (
    <div>
      <div>
        <div className="pds-erroredInput">
          <div className="pds-labeledInput">
            <strong><label htmlFor="firstNameADD" className="pds-label">
              Search a firm by tax id or eid
              <span className="pds-label-required" aria-hidden="true"></span> </label></strong>
            <input id="firmSearchText" aria-label="" type="text" className="pds-validation col-3 force-caps" 
            required
            onKeyPress={(event) => {
              if (!/[0-9,A-Z,a-z]/.test(event.key)) {
                event.preventDefault();
              }
            }} />
          </div>
        </div>
      </div>
      <br></br>
      <button
        className="pds-button pds-button-primary"
        data-gtm="modal-cta"
        id="firmSearchButton"
        onClick={handleSubmit}
      >
        Search
      </button>
    </div>
  );
}